export const version = "6.4.2";
export const major = Number("6");
export const minor = Number("4");
export const patch = Number("2");
export const prerelease = undefined;
export default version;